import { useMutation, useQueryClient } from '@tanstack/react-query';
import requestPostTodaysEscapesScheduleGeneration, {
  TodaysEscapesScheduleGenerationParams,
} from '~/queries/customerCommunication/requestPostTodaysEscapesScheduleGeneration';

import { heroPlannerScheduleDebugQueryKeys } from './useHeroPlannerScheduleDebug';

/**
 * Re-runs tail deal generation for a country group's send date (hero-planner-admin only).
 */
export function useRegenerateTailDeals() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: TodaysEscapesScheduleGenerationParams) => requestPostTodaysEscapesScheduleGeneration(params),
    onSuccess: () => {
      // the debugger's results and pre-send checks are stale as soon as schedules are marked as regenerating
      queryClient.invalidateQueries({ queryKey: heroPlannerScheduleDebugQueryKeys.schedules() });
      queryClient.invalidateQueries({ queryKey: heroPlannerScheduleDebugQueryKeys.preSendChecks() });
    },
  });
}
